import { render } from "./SkillsAuditReport.vue?vue&type=template&id=12122e4e&scoped=true"
import script from "./SkillsAuditReport.vue?vue&type=script&lang=js"
export * from "./SkillsAuditReport.vue?vue&type=script&lang=js"

import "./SkillsAuditReport.vue?vue&type=style&index=0&id=12122e4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12122e4e"]])

export default __exports__